import "./index.css";
import "dayjs/locale/de";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";

import { StrictMode } from "react";
import * as ReactDOM from "react-dom/client";
import { pdfjs } from "react-pdf";

import App from "~/App";

import initI18n from "./i18n/setup";

initI18n({ debug: false });
/*pdfjs.GlobalWorkerOptions.workerSrc = new URL("pdfjs-dist/build/pdf.worker.min.js", import.meta.url).toString();*/
pdfjs.GlobalWorkerOptions.workerSrc = "/pdf.worker.min.js";

const rootElement = document.getElementById("root")!;
if (!rootElement.innerHTML) {
    const root = ReactDOM.createRoot(rootElement);
    root.render(
        <StrictMode>
            <App />
        </StrictMode>,
    );
}
